<!--
  TeleworkEditDialog.vue
    Telework Edit Dialog Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog v-model="mVisible" persistent max-width="400px">
    <div class="hm-td">
      <div class="hm-bg-primary hm-td-title">
        勤怠編集
        <div class="hm-td-delete" :class="{'hm-td-delete-hide': checkDispDeleteIcon}">
          <v-btn icon absolute flat color="white" class="hm-td-delete-icon" @click="onClickDelete"><v-icon>delete</v-icon></v-btn>
        </div>
      </div>

      <!-- 更新日時 -->
      <v-layout row wrap justify-center class="hm-td-updatedate" :class="{'hm-td-updatedate-disp':checkUpdated}">
        <div>(更新日時 : {{mTeleworkEditData.update_date}})</div>
      </v-layout>

      <!-- 種別名称 -->
      <v-layout row wrap class="hm-td-category">
        <v-flex xs2>
          <v-icon large color="orange darken-2" class="hm-td-icon">category</v-icon>
        </v-flex>
        <v-flex xs8 class="hm-td-category-text">
          <div>{{mDispCategory}}</div>
        </v-flex>
      </v-layout>

      <v-divider />

      <!-- 勤務時間入力 -->
      <v-layout row wrap class="hm-td-datetime">
        <v-flex xs2 class="hm-td-datetime-icon">
          <v-icon large color="green darken-4">access_time</v-icon>
        </v-flex>

        <v-flex xs5>
          <v-menu
            ref="mDpicker"
            v-model="mDpicker"
            :close-on-content-click="false"
            :return-value.sync="mTeleworkEditData.date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
            v-bind:disabled="isDatePickerDisabled"
           >
            <v-text-field
              class="hm-ewd-text-date mr-3"
              slot="activator"
              v-model="mTeleworkEditData.date"
              readonly
              background-color="grey lighten-2"
              v-bind:disabled="isDatePickerDisabled"
            ></v-text-field>
            <v-date-picker
             v-model="mTeleworkEditData.date"
             scrollable
            >
              <v-btn flat color="primary" @click="mDpicker = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.mDpicker.save(mTeleworkEditData.date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs5>
          <v-menu
            ref="mTpicker_ref"
            v-model="mTpicker"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="mTeleworkEditData.time"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              class="hm-ewd-text-time mr-3"
              slot="activator"
              v-model="mTeleworkEditData.time"
              readonly
              background-color="grey lighten-2"
            ></v-text-field>
            <v-time-picker
              v-if="mTpicker"
              v-model="mTeleworkEditData.time"
              full-width
              format="24hr"
              actions
            > <!--v-ifによって、再度時間設定画面を表示したときに時間から入力できるようになる-->
              <v-btn flat color="primary" @click="mTpicker = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.mTpicker_ref.save(mTeleworkEditData.time)">OK</v-btn>
            </v-time-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-divider />

      <!-- 位置情報 -->
      <v-layout row wrap align-center class="hm-td-location">
        <v-flex xs2 class="hm-td-location-icon">
          <v-icon large color="pink lighten-1">location_on</v-icon>
        </v-flex>
        <v-flex xs10>
          <div :class="{'hm-hide': !mMapDisp}">
            <map-area
              :pmapid="mMapName"
              ref="mapobjTwEdit"
              class="hm-td-map-area"
            >
            </map-area>
          </div>
          <div :class="{'hm-hide': mMapDisp}" class="hm-td-location-disp">( 位置情報なし )</div>
        </v-flex>
      </v-layout>

      <v-divider />

      <!-- コメント -->
      <v-layout row wrap class="hm-td-memo">
        <v-flex xs2><v-icon large color="blue">message</v-icon></v-flex>
        <v-flex xs8>
          <v-form v-model="mTdEditFormValid">
            <v-textarea
              v-model="mTeleworkEditData.comment"
              :rules="[mTdEditMsgRules.counter]"
              label="Comment"
              rows=4
              box
              caption
            >
            </v-textarea>
          </v-form>
        </v-flex>
        <v-flex xs1>
          <v-btn small icon flat color="primary" @click="onClickMessageClear">
            <v-icon>backspace</v-icon>
          </v-btn>
        </v-flex>
       </v-layout>
      <v-divider />

      <!-- 更新ボタン -->
      <v-layout wrap justify-center>
        <div>
          <v-btn
            color="primary"
            class="white--text hm-td-update-btn"
            :disabled="(!mTdEditFormValid) || (mIsUpdating)"
            @click="onClickUpdate"
          >
            保存
          </v-btn>
        </div>
        <div>
          <v-btn
            color="secondary"
            class="white--text hm-td-update-btn"
            @click="onClickClose"
          >
            CLOSE
          </v-btn>
        </div>
      </v-layout>

    </div>

    <!-- ダイアログ設定 -->
    <errorinfo-dialog ref="errorInfoDialog">
      <div slot="msg">{{ mErrMsg }}</div>
    </errorinfo-dialog>
    <confirm-dialog ref="confirmDialog">
      <div slot="msg">{{ mConfirmMsg }}</div>
    </confirm-dialog>
    <systeminfo-dialog ref="systemInfoDialog">
      <div slot="msg">{{ mSysMsg }}</div>
    </systeminfo-dialog>

  </v-dialog>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import {
  TeleworkCategory,
  TeleworkCategoryNames,
  isNullorUndefined,
  getGeoLocation
} from '@/common'
import ErrorInfoDialog from '@/components/dialogs/ErrorInfoDialog'
import SystemInfoDialog from '@/components/dialogs/SystemInfoDialog'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import MapOSMOL from '@/components/MapOSMOL'

export default {
  name: 'TeleworkEditDialog',
  data: () => ({
    mVisible: false,
    mTeleworkEditData: {},
    mTeleworkCategory: TeleworkCategory,
    mTeleworkCategoryNames: TeleworkCategoryNames,
    mDispCategory: '',
    mDpicker: false,
    mTpicker: false,
    mGeolocation: {
      lat: '',
      lon: ''
    },
    mMapName: 'hm-map-tw-edit',
    mMapDisp: true,
    mMapZoom: 15,
    mErrMsg: '',
    mSysMsg: '',
    mConfirmMsg: '',
    mIsUpdating: false,
    mTdEditFormValid: true,
    mTdEditMsgRules: {
      counter: v => ((v == null) || (v.length <= 100)) || '100文字以内で入力してください',
    },
    mRetCode: {
      DATETIME_CONTEXT_OK: 0,
      DATETIME_CONTEXT_NG_PAST: 1,
      DATETIME_CONTEXT_NG_FUTURE: 2,
    },
    mRecentSendData: null
  }),
  components: {
    'errorinfo-dialog': ErrorInfoDialog,
    'systeminfo-dialog': SystemInfoDialog,
    'confirm-dialog': ConfirmDialog,
    'map-area': MapOSMOL,
  },
  mounted: function () {
    this.$log.debug('# Telework Edit')
    this.$on('onClickTeleworkEdit', this.onClickTeleworkEdit)
  },
  destroyed: function () {
    this.$log.debug('# Telework Edit')
  },
  computed: {
    ...mapState({
      mPrevTeleworkData: state => state.telework.sPrevTeleworkData,
      mTeleworkList: state => state.telework.sTeleworkList,
      mNextTeleworkData: state => state.telework.sNextTeleworkData,
    }),
    // Judge whether to disable from category
    isDatePickerDisabled: function () {
      if (this.mTeleworkEditData.category === this.mTeleworkCategory.START) {
        // 勤務開始の場合
        return true
      }
      return false
    },
    checkDispDeleteIcon: function () {
      return (isNullorUndefined(this.mTeleworkEditData.workinghour_id))
    },
    checkUpdated: function () {
      return (this.mTeleworkEditData.update_date !== '')
    },
  },
  methods: {
    // -------------------------------------------------------------------------
    // A Handler on User Settings Menu
    onClickTeleworkEdit: async function (data) {
      if (this.mVisible === true) {
        // 勤怠編集ダイアログ表示済みの場合、重複表示を回避
        return
      }
      if (!this.checkHolidayDataContext(data.list_row)) {
        this.mSysMsg = '休暇データが登録済みのため、勤怠情報を登録できません。'
        this.$refs.systemInfoDialog.$emit('show')
        return
      }

      this.mTdEditFormValid = true
      this.mTeleworkEditData = data
      this.mRecentSendData = null
      this.mDispCategory = this.mTeleworkCategoryNames[Number(this.mTeleworkEditData.category) - 1]

      if (this.mTeleworkEditData.time === '') {
        this.mTeleworkEditData.time = '00:00'
      }

      this.mVisible = true  // Show Dialog

      const locate = await getGeoLocation(this.$store.getters.isMobile, this.$store.getters.isGnssReady)
      if (locate.result === 'ng') {
        this.mMapDisp = false
        this.mErrMsg = locate.alertMsg
        this.$refs.errorInfoDialog.$emit('show')
      }
      else {
        locate.lon = Number(locate.lon)
        locate.lat = Number(locate.lat)

        // 地図をクリアしてから再描画する
        this.$refs.mapobjTwEdit.renderMap()
        this.$refs.mapobjTwEdit.setMarker(this.mMapZoom, locate.lon, locate.lat)
      }
      this.mGeolocation.lat = locate.lat
      this.mGeolocation.lon = locate.lon
    },
    // -------------------------------------------------------------------------
    // On Click Update Telework
    onClickUpdate: async function () {
      if (!this.mTdEditFormValid || this.mIsUpdating) {
        return
      }
      if (!isNullorUndefined(this.mRecentSendData) &&
          (this.mRecentSendData.date + this.mRecentSendData.time) === (this.mTeleworkEditData.date + this.mTeleworkEditData.time)) {
        // 前回送信した勤怠データと同じ日時を入力
        this.mErrMsg = '同じ日時の勤怠データが登録済みです。'
        this.$refs.errorInfoDialog.$emit('show')
        return
      }

      const send_data = this.getSendData()

      // 入力チェック
      if ((send_data.teleworkLog.date === '' || isNullorUndefined(send_data.teleworkLog.date)) ||
          (send_data.teleworkLog.time === '' || isNullorUndefined(send_data.teleworkLog.time))) {
        // 日付または時間が未入力
        this.mErrMsg = '日付または時間が未入力です。'
        this.$refs.errorInfoDialog.$emit('show')
        return
      }
      if (send_data.teleworkLog.category === this.mTeleworkCategory.START &&
          send_data.teleworkLog.date.slice(-2) !== this.mTeleworkEditData.linked_date.slice(-2)) {
        // 勤務開始で、別の日付を入力
        this.mErrMsg = '勤務開始の日付は変更できません。'
        this.$refs.errorInfoDialog.$emit('show')
        return
      }

      // 直前直後の日時を超過していないかチェック
      let ret_code = this.checkDatetimeContext(send_data.teleworkLog.date, send_data.teleworkLog.time)
      if (ret_code === this.mRetCode.DATETIME_CONTEXT_NG_PAST) {
        // 直前のデータより過去の日時が入力された
        this.mErrMsg = '直前の勤務時間よりも前の時間は登録できません。'
        this.$refs.errorInfoDialog.$emit('show')
        return
      }
      else if (ret_code === this.mRetCode.DATETIME_CONTEXT_NG_FUTURE) {
        // 直後のデータより未来の日時が入力された
        this.mErrMsg = '直後の勤務時間よりも後の時間は登録できません。'
        this.$refs.errorInfoDialog.$emit('show')
        return
      }

      this.mIsUpdating = true   // ボタン連打による重複送信を防止

      this.$log.debug('send : ' + JSON.stringify(send_data))
      let result = await this.$store.dispatch('aEditTeleworkData', send_data)
      this.$log.debug('result : ' + JSON.stringify(result))
      if ((!result.error) && (!result.body.error)) {
        // 登録の場合、ログインユーザの行先情報を更新
        if (isNullorUndefined(send_data.teleworkLog.workinghour_id)) {
          //this.$log.debug('★登録したため、直近の勤務種別を更新(' + result.body.latest_wh_category + ')')
          this.$store.dispatch('aSetLatestTeleworkCategory', result.body.latest_wh_category)

          /*switch (result.body.latest_wh_category) {
            case this.mTeleworkCategory.START:
            case this.mTeleworkCategory.LEAVE:
            case this.mTeleworkCategory.SEATED:
              // リストに存在しない場合は追加
              this.$store.dispatch('aAddTeleworkingUserList', send_data.teleworkLog.staff_id.toString())
              break
            case this.mTeleworkCategory.END:
              // リストから削除
              this.$store.dispatch('aDelTeleworkingUserList', send_data.teleworkLog.staff_id.toString())
              break
            default:
              break
          }*/
        }
        this.mRecentSendData = send_data.teleworkLog
        this.mSysMsg = '更新しました。'
        this.$refs.systemInfoDialog.$emit('show')
        this.onClickClose()
      }
      else {
        this.mErrMsg = '更新に失敗しました。しばらくしてから再度実行して下さい。'
        this.$refs.errorInfoDialog.$emit('show')
      }
      this.mIsUpdating = false
    },
    // -------------------------------------------------------------------------
    // On Click delete Telework
    onClickDelete: function () {
      this.mConfirmMsg = '削除してもよろしいですか？'
      this.$refs.confirmDialog.$emit('show', this.deleteOkCallback)
    },
    // -------------------------------------------------------------------------
    // callback on accept telework data delete
    deleteOkCallback: async function () {
      const send_data = this.getSendData()

      this.$log.debug('send : ' + JSON.stringify(send_data))
      let result = await this.$store.dispatch('aDeleteTeleworkData', send_data)
      this.$log.debug('result : ' + JSON.stringify(result))
      if ((!result.error) && (!result.body.error)) {
        this.$store.dispatch('aSetLatestTeleworkCategory', result.body.body.latest_wh_category)

        /*switch (result.body.body.latest_wh_category) {
          case this.mTeleworkCategory.START:
          case this.mTeleworkCategory.LEAVE:
          case this.mTeleworkCategory.SEATED:
            // リストに存在しない場合は追加
            this.$store.dispatch('aAddTeleworkingUserList', send_data.teleworkLog.staff_id.toString())
            break
          case this.mTeleworkCategory.END:
          default:
            // リストから削除
            this.$store.dispatch('aDelTeleworkingUserList', send_data.teleworkLog.staff_id.toString())
            break
        }*/

        this.mSysMsg = '削除しました。'
        this.$refs.systemInfoDialog.$emit('show')
        this.onClickClose()
      }
      else {
        this.mErrMsg = '削除に失敗しました。しばらくしてから再度実行して下さい。'
        this.$refs.errorInfoDialog.$emit('show')
      }
    },
    // -------------------------------------------------------------------------
    // On Click Close
    onClickClose: function () {
      this.mVisible = false
      this.mMapDisp = true
      let elm = document.getElementById('hm-map-tw-edit')
      if (elm !== null) {
        elm.innerHTML = ''
        this.$refs.mapobjTwEdit.clearMarker()
      }
    },
    // -------------------------------------------------------------------------
    // On Click Message Clear
    onClickMessageClear: function () {
      this.mTeleworkEditData.comment = ''
    },
    // -------------------------------------------------------------------------
    // get update telework data
    getSendData: function () {
      this.mTeleworkEditData.staff_id = this.$store.getters.loginUserInfo.staff_id
      this.mTeleworkEditData.lat = this.mGeolocation.lat
      this.mTeleworkEditData.lon = this.mGeolocation.lon
      this.mTeleworkEditData.updated = 1
      this.mTeleworkEditData.linked_date = this.mTeleworkEditData.linked_date
      return {
        userId: this.$store.getters.loginUserId,
        companyId: this.$store.getters.loginUserCompanyId,
        teleworkLog: this.mTeleworkEditData,
      }
    },
    // -------------------------------------------------------------------------
    // check the context of inputed datetime
    // [OUT] DATETIME_CONTEXT_OK(0)        ：OK
    //       DATETIME_CONTEXT_NG_PAST(1)   ：NG(直前のデータより過去日時)
    //       DATETIME_CONTEXT_NG_FUTURE(2) ：NG(直後のデータより未来日時)
    checkDatetimeContext: function (date, time) {
      //this.$log.debug('★[checkDatetimeContext]')
      const datetime = this.shapeDatetime(date, time)
      //this.$log.debug('★  datetime(' + datetime + ')')
      let compare_datetime = ''   // 比較対象として取得する日時

      //--- 編集中のデータより「前」の入力済みデータを検索 ----------
      // １：日ごとのループ
      for (let i = (this.mTeleworkEditData.list_row - 1); i >= 0; i--) {
        //this.$log.debug('★  (1)直前データチェック [' + i + '/' + 0 + '] 種別：' + this.mTeleworkEditData.category)
        // ２：同日内で種別ごとのループ
        let max_category = 4  // 種別数分ループするための初期値(種別数4)
        if (i === (this.mTeleworkEditData.list_row - 1)) {
          // 初回ループの場合のみ、編集中の種別の１つ前を基準にする
          max_category = this.mTeleworkEditData.category - 1
        }
        for (let j = max_category; j > 0; j--) {
          //this.$log.debug('★     (2) [' + j + '/' + max_category + ']')
          switch (j) {
            case TeleworkCategory.START:
              if (isNullorUndefined(this.mTeleworkList[i].startId)) {
                continue
              }
              // データあり
              compare_datetime = this.shapeDatetime(this.mTeleworkList[i].date, this.mTeleworkList[i].startTime)
              //this.$log.debug('★       (勤務開始) 比較対象日時：' + compare_datetime)
              break
            case TeleworkCategory.LEAVE:
              if (isNullorUndefined(this.mTeleworkList[i].leaveId)) {
                continue
              }
              // データあり
              compare_datetime = this.shapeDatetime(this.mTeleworkList[i].date, this.mTeleworkList[i].leaveTime)
              //this.$log.debug('★       (離席) 比較対象日時：' + compare_datetime)
              break
            case TeleworkCategory.SEATED:
              if (isNullorUndefined(this.mTeleworkList[i].seatedId)) {
                continue
              }
              // データあり
              compare_datetime = this.shapeDatetime(this.mTeleworkList[i].date, this.mTeleworkList[i].seatedTime)
              //this.$log.debug('★       (着席) 比較対象日時：' + compare_datetime)
              break
            case TeleworkCategory.END:
              if (isNullorUndefined(this.mTeleworkList[i].endId)) {
                continue
              }
              // データあり
              compare_datetime = this.shapeDatetime(this.mTeleworkList[i].date, this.mTeleworkList[i].endTime)
              //this.$log.debug('★       (勤務終了) 比較対象日時：' + compare_datetime)
              break
          }
          // 比較対象日付を取得した場合
          break
        } // end of ループ２

        if (compare_datetime !== '') {
          // 比較対象日時を取得した場合は、ループ終了
          break
        }
      } // end of ループ１
      //this.$log.debug('★日時比較 datetime: ' + datetime + '、比較対象: ' + compare_datetime)
      if (compare_datetime !== '' && datetime <= compare_datetime) {
        // 入力した日時が直前のデータよりも過去の日時である場合
        //this.$log.debug('★  → 直前のデータよりも過去')
        return this.mRetCode.DATETIME_CONTEXT_NG_PAST
      }
      //this.$log.debug('★  → 前月以前のデータ[' + JSON.stringify(this.mPrevTeleworkData) + ']')
      if (compare_datetime === '' && !isNullorUndefined(this.mPrevTeleworkData)) {
        if ((this.mPrevTeleworkData.category <= TeleworkCategory.END) &&
            (datetime <= (this.mPrevTeleworkData.input_date + this.mPrevTeleworkData.input_hour))) {
          // 前月以前の最初のデータの勤務種別が勤務開始・離席・着席・勤務終了のいずれか、かつ
          // 入力した日時の方が過去の日時である場合
          //this.$log.debug('★  → 前月以前のデータ(' + (this.mPrevTeleworkData.input_date + this.mPrevTeleworkData.input_hour) + ')よりも過去')
          return this.mRetCode.DATETIME_CONTEXT_NG_PAST
        }
      }

      //--- 編集中のデータより「後」の入力済みデータを検索 ----------
      compare_datetime = ''
      // １：日ごとのループ
      const count = this.mTeleworkList.length
      for (let i = (this.mTeleworkEditData.list_row - 1); i < count; i++) {
        //this.$log.debug('★  (1)直後データチェック [' + i + '/' + count + '] 種別：' + this.mTeleworkEditData.category)
        // ２：同日内で種別ごとのループ
        let min_category = 1  // 種別数分ループするための初期値(種別数4)
        if (i === (this.mTeleworkEditData.list_row - 1)) {
          // 初回ループの場合のみ、編集中の種別の次を基準にする
          min_category = this.mTeleworkEditData.category + 1
        }
        for (let j = min_category; j <= 4; j++) {
          //this.$log.debug('★     (2) [' + j + '/' + min_category + ']')
          switch (j) {
            case TeleworkCategory.START:
              if (isNullorUndefined(this.mTeleworkList[i].startId)) {
                continue
              }
              // データあり
              compare_datetime = this.shapeDatetime(this.mTeleworkList[i].date, this.mTeleworkList[i].startTime)
              //this.$log.debug('★       (勤務開始) 比較対象日時：' + compare_datetime)
              break
            case TeleworkCategory.LEAVE:
              if (isNullorUndefined(this.mTeleworkList[i].leaveId)) {
                continue
              }
              // データあり
              compare_datetime = this.shapeDatetime(this.mTeleworkList[i].date, this.mTeleworkList[i].leaveTime)
              //this.$log.debug('★       (離席) 比較対象日時：' + compare_datetime)
              break
            case TeleworkCategory.SEATED:
              if (isNullorUndefined(this.mTeleworkList[i].seatedId)) {
                continue
              }
              // データあり
              compare_datetime = this.shapeDatetime(this.mTeleworkList[i].date, this.mTeleworkList[i].seatedTime)
              //this.$log.debug('★       (着席) 比較対象日時：' + compare_datetime)
              break
            case TeleworkCategory.END:
              if (isNullorUndefined(this.mTeleworkList[i].endId)) {
                continue
              }
              // データあり
              compare_datetime = this.shapeDatetime(this.mTeleworkList[i].date, this.mTeleworkList[i].endTime)
              //this.$log.debug('★       (勤務終了) 比較対象日時：' + compare_datetime)
              break
            default:
              break
          }
          // 比較対象日付を取得した場合
          break
        } // end of ループ２

        if (compare_datetime !== '') {
          // 比較対象日時を取得した場合は、ループ終了
          break
        }
      } // end of ループ１
      if (compare_datetime !== '' && datetime >= compare_datetime) {
        // 入力した日時が直後のデータよりも未来の日時である場合
        //this.$log.debug('★  → 直後のデータよりも未来')
        return this.mRetCode.DATETIME_CONTEXT_NG_FUTURE
      }
      //this.$log.debug('★  → 翌月以降のデータ[' + JSON.stringify(this.mNextTeleworkData) + ']')
      if (compare_datetime === '' && !isNullorUndefined(this.mNextTeleworkData)) {
        if ((this.mNextTeleworkData.category <= TeleworkCategory.END) &&
            (datetime >= (this.mNextTeleworkData.input_date + this.mNextTeleworkData.input_hour))) {
          // 翌月以降の最初のデータの勤務種別が勤務開始・離席・着席・勤務終了のいずれか、かつ
          // 入力した日時の方が未来の日時である場合
          //this.$log.debug('★  → 翌月以降のデータ(' + (this.mNextTeleworkData.input_date + this.mNextTeleworkData.input_hour) + ')よりも未来')
          return this.mRetCode.DATETIME_CONTEXT_NG_FUTURE
        }
      }
      //this.$log.debug('★  → OK')
      return this.mRetCode.DATETIME_CONTEXT_OK
    },
    // -------------------------------------------------------------------------
    // check the context of send data
    // [input] date : YYYY-MM-dd形式
    // [out]  true : 同日登録済みの勤怠データなし
    //        false: 同日登録済みの勤怠データあり
    checkHolidayDataContext: function (listRow) {
      // 指定の日付に、すでに休暇データが登録されているかチェック
      if (!isNullorUndefined(this.mTeleworkList[listRow - 1].holidayId)) {
        return false
      }
      return true
    },
    // -------------------------------------------------------------------------
    // shaping datetime
    // date→YYYY-MM-DD 、time→((YYYY/)MM/dd )hh:mmを結合してYYYYMMddhhmm形式に整形する
    shapeDatetime: function (date, time) {
      //this.$log.debug('○[shapeDatetime]date:' + date + '、time:' + time)
      let ret_datetime = ''
      let timeDivNum = time.split('/').length
      if (timeDivNum > 1) {
        // 年月日またぎの場合('/'で分割できる場合を日またぎとみなす)

        if (timeDivNum === 3) {
          // 年またぎ
          ret_datetime = time.slice(0, 10).replace(/\//g, '') + time.slice(11).replace(/:/g, '')
        }
        else {
          // 月日またぎ
          ret_datetime = date.slice(0, 4) + time.slice(0, 5).replace(/\//g, '') + time.slice(6).replace(/:/g, '')
        }
      }
      else {
        // 年月日またぎなし
        ret_datetime = date.slice(0, 10).replace(/-/g, '') + time.replace(/:/g, '')
      }
      return ret_datetime
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-td {
  text-align: center;
  background-color: whitesmoke;
}
.hm-td-title {
  padding: 20px;
  color: white;
  font-size: 1.2em;
  font-weight: bold;
}
.hm-td-delete {
  float: right;
  margin-top: -5px;
  margin-right: 30px;
}
.hm-td-delete-icon {
  z-index: 210;
}
.hm-td-delete-hide {
  display: none;
}
.hm-td-icon {
  margin-top: 7px;
}
.hm-td-updatedate {
  display: none;
  margin-top: 10px;
  font-size: 0.9em;
}
.hm-td-updatedate-disp {
  display: block;
}
.hm-td-category {
  height: 50px;
  line-height: 50px;
  font-size: 1.1em;
  font-weight: bold;
}
.hm-td-category-text {
  text-align: left;
  padding-left: 5px;
}
.hm-td-datetime {
  height: 60px;
  line-height: 60px;
  font-size: 1.5em;
  font-weight: bold;
}
.hm-td-datetime-icon {
  padding-top: 7px;
}
.hm-td-location {
  font-size: 0.9em;
  font-weight: normal;
}
.hm-td-location-icon {
  height: 20vh;   /*アイコン位置を上寄せするために、地図領域の高さと合わせる*/
  padding-top: 10px;
}
.hm-td-location-disp {
  text-align: left;
}
.hm-td-map-area {
  width: 95%;
  height: 20vh;
  margin-top: 5px;
  margin-bottom: 5px;
}
.hm-td-memo {
  padding: 5px;
  margin-top: 10px;
  font-size: 0.5em;
}
.hm-td-update-btn {
  margin: 20px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/TeleworkEditDialog.vue